export const amazonRetryExpBackoff = (attemptIndex: number) => {
  const delay = 15000 * 3 ** attemptIndex;
  return delay;
};
